const MapStyle = {
  DEFAULT: 'mapbox://styles/geollectryan/clrah6383006f01qq4n9eapol',
};

export default MapStyle;
